<template>
    <lv-column-text
        :align="align"
        :link="link"
        :row="showRow"
        :row-index="rowIndex"
        :field="field"
        :editable="lv_editable"
        :data-type="dataType"
        :tooltip="tooltip">
        <slot :row="row" :rowIndex="rowIndex" :align="align" :field="field" :editable="lv_editable">
            <link-radio
                v-if="!fixedRow"
                :value="showRow[field] === trueValue"
                @input="val=>$set(showRow,field,!!val?trueValue:falseValue)"
                :size="size"
                :color="color"
                :active-icon="activeIcon"
                :inactive-icon="inactiveIcon"
                :active-color="activeColor"
                :inactive-color="inactiveColor"
                :disabled="!lv_editable"/>
        </slot>
    </lv-column-text>
</template>

<script>
    import {ColumnItemMixin} from "../mixins";
    import LinkRadio from "../../radio/link-radio";
    import LvColumnText from "../lv-column-text";

    export default {
        name: 'link-table-column-checkbox-item',
        components: {LvColumnText, LinkRadio},
        mixins: [
            ColumnItemMixin
        ],
        data() {
            return {}
        },
        props: {
            value: {type: Boolean,},
            size: {default: 'small'},
            color: {default: 'primary',},
            activeIcon: {type: String,},
            inactiveIcon: {type: String,},
            activeColor: {type: String,},
            inactiveColor: {type: String},

            trueValue: {default: 'Y'},
            falseValue: {default: 'N'},
        },
    };
</script>
